import Logger from "@cappelendamm/logger";
import GetOrderPipelines from "../queries/GetOrderPipelinesTemp.pim.js";
export const fetchOrderPipelines = async ({ orderId }, { client }) => {
    const data = await client.pim.request(GetOrderPipelines, { orderId });
    if (!data.order.get) {
        Logger.log(`No order found for orderId: ${orderId}`);
        return;
    }
    return data.order.get;
};
